import { ref, uploadBytesResumable, getDownloadURL, UploadTask, deleteObject } from "firebase/storage";
import useFirebaseConfig from "./useFirebaseConfig";
import { Dispatch, SetStateAction } from "react";

interface ProgressSnapshot {
  bytesTransferred: number;
  totalBytes: number;
}

const useStorage = () => {
  const { storage } = useFirebaseConfig();

  const extractFileNameFromUrl = (url: string): string | null => {
    // URL에서 파일 경로 부분을 추출합니다.
    const match = url.match(/\/o\/([^?]+)/);
    if (match) {
        // 파일 경로를 디코딩합니다.
        const filePath = decodeURIComponent(match[1]);
        // 파일 이름을 추출합니다.
        const fileName = filePath.split('/').pop();
        return fileName || null;
    }
    return null;
};

  async function uploadStorage(
    table: string,
    file: File,
    setProgress: Dispatch<SetStateAction<number>>,
    contentType?: string
  ): Promise<string> {
    console.log("Original file type:", file.type);
    console.log("Specified content type:", contentType);
    
    const finalContentType = contentType || file.type;
    console.log("Final content type being used:", finalContentType);
    
    const storageRef = ref(storage, `${table}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file, {
      contentType: finalContentType
    });
    const promise = new Promise<string>((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot: ProgressSnapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if (setProgress instanceof Function) {
            setProgress(progress);
          }
        },
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/unauthorized":
              reject("storage/unauthorized");
              // User doesn't have permission to access the object
              break;
            case "storage/canceled":
              reject("storage/canceled");
              // User canceled the upload
              break;
            case "storage/unknown":
              reject("storage/unknown");
              // Unknown error occurred, inspect error.serverResponse
              break;
            default:
              break;
          }
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
    return promise;
  }

  const deleteStorage = async (path:string, fileUrl: string) => {
    if (!path || !fileUrl) {
        return false;
    }
    const fileName = extractFileNameFromUrl(fileUrl);
    if (!fileName) {
        console.error("Failed to extract file name from URL");
        return false;
    }
    const fileRef = ref(storage, `${path}/${fileName}`);
    try {
        await deleteObject(fileRef);
        console.log(`File ${fileName} deleted successfully`);
        return true;
    } catch (err) {
        console.error("Error deleting file:", err);
        return false;
    }
  };  

  

  return {
    uploadStorage,
    deleteStorage
  };
};

export default useStorage;